import React from "react";

const ComplianceSecurity = () => {
  return (
    <section className="py-14 bg-white border-t-2 border-[#f4f4f4]">
      <div className="container mx-auto px-4">
        
        {/* Section title */}
        <h2 className="text-lg font-semibold text-[#111827] mb-6">
          Compliance & security
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

          {/* LEFT CARD */}
          <div className="border border-gray-200 rounded-lg p-5 bg-[#F9F9F9]">
            
            {/* Top pills */}
            <div className="flex flex-wrap gap-2 mb-4">
              <span className="px-3 py-1 text-xs text-[#0F766E] bg-[#E6F8F3] rounded-md">
                Encryption at rest & in transit
              </span>
              <span className="px-3 py-1 text-xs text-[#0F766E] bg-[#E6F8F3] rounded-md">
                SSO & RBAC
              </span>
            </div>

            {/* Status row */}
            <div className="flex flex-wrap gap-4 text-xs text-[#6B7280]">
              <span className="border border-gray-200 rounded-md px-3 py-1">
                SOC 2 Type II
                <span className="ml-1 text-gray-400">In progress</span>
              </span>

              <span className="border border-gray-200 rounded-md px-3 py-1">
                PCI DSS
                <span className="ml-1 text-gray-400">Not in scope</span>
              </span>
            </div>
          </div>

          {/* RIGHT CARD */}
          <div className="border border-gray-200 rounded-lg p-5 bg-[#F9F9F9]">
            
            <h4 className="text-sm font-semibold text-[#111827] mb-1">
              Backed by
            </h4>

            <p className="text-sm text-[#6B7280] mb-4">
              Industry operators and fintech investors.
            </p>

            <div className="flex gap-2">
              <span className="px-3 py-1 text-xs text-[#0F766E] bg-[#E6F8F3] rounded-md">
                Venture-backed
              </span>
              <span className="px-3 py-1 text-xs text-[#0F766E] bg-[#E6F8F3] rounded-md">
                Banking partners
              </span>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ComplianceSecurity;
